import produce from "immer";
import { AuthTypes } from "./types";

const initialState = {
  isAuthenticated: false,
  user: {},
  userPref: {}
};

export const Auth = (state = initialState, action) => {
  const nextState = produce(state, (draftState) => {
    switch (action.type) {
      case AuthTypes.LOGIN_SUCCESS:
        draftState.isAuthenticated = true;
        draftState.user = action.payload;
        break;
      case AuthTypes.PREF:
        draftState.userPref = action.payload;
        break;
      case AuthTypes.SET_USER_PREF:
        draftState.userPref = action.payload;
        break;
      case AuthTypes.LOGOUT:
        draftState.isAuthenticated = false;
        draftState.user = {};
        draftState.userPref = {};
        break;
      default:
        break;
    }
  });
  return nextState;
};
